import { FormControl, FormHelperText, Stack, TextField } from '@mui/material';
import React from 'react';
import { useTranslation } from '../../../contexts/TranslationContext';
import { FormFieldProps } from './index';
import { useFormErrors } from '../../../contexts/FormContext';

export default function TextareaFormField({
    type,
    name,
    label,
    value,
    required,
    disabled,
    cssClassName,
    help,
    onChange,
    onKeyUp,
}: FormFieldProps) {
    const { translate } = useTranslation();

    const { error } = useFormErrors(name);

    return (
        <FormControl fullWidth>
            <Stack spacing={0.5}>
                <TextField
                    id={name}
                    name={name}
                    InputLabelProps={{
                        sx: { lineHeight: 1, color: 'text.secondary', mt: 0.5 },
                    }}
                    label={translate(label)}
                    value={value}
                    variant="outlined"
                    onChange={event => onChange(event.target.value)}
                    onKeyUp={onKeyUp}
                    error={Boolean(error)}
                    required={required}
                    type={type}
                    multiline
                    rows={'5'}
                />
                {Boolean(error) && (
                    <FormHelperText error id={name + '-error'}>
                        {translate(error ?? 'error')}
                    </FormHelperText>
                )}
            </Stack>
        </FormControl>
    );
}
